import { useEffect, useState } from 'react';
import { AppStoreUrl, GooglePlayUrl } from '@/common/constants/urls';

export function useMobileDevice() {
  const [isMobileDevice, setIsMobileDevice] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const detectMobileDevice = () => {
      const userAgent = navigator.userAgent;
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
      const isTablet = /(iPad|Android(?!.*Mobile))/i.test(userAgent);

      return isMobile || isTablet;
    };

    setIsMobileDevice(detectMobileDevice());
  }, []);

  return isMobileDevice;
}

export function getAppStoreUrl(): string {
  const userAgent = navigator.userAgent;
  const isIOS = /iPad|iPhone|iPod/.test(userAgent);
  const isAndroid = /Android/.test(userAgent);

  if (isIOS) {
    return AppStoreUrl;
  }

  if (isAndroid) {
    return GooglePlayUrl;
  }

  return AppStoreUrl;
}
